export default __webpack_public_path__ + "static/media/eshika_Resume.docx.8ffca463.pdf";